import { ControlSheetAnnotationDTO } from '@/types/controlsheet'
import { ControlSheetAnnotation, ControlSheetNote } from '../types/types'
import { noteMapper } from './noteUtils'

export const annotationMapper =
    (tempNotes?: ControlSheetNote[]) =>
    (annotation: ControlSheetAnnotationDTO): ControlSheetAnnotation => ({
        id: annotation.id,
        dutyCode: annotation.dutyCode,
        tripNumber: annotation.tripNumber,
        runNumber: annotation.runNumber,
        annotationType: annotation.annotationType,
        departureTime: annotation.departureTime,
        identifier: annotation.identifier,
        serviceNotOperated: annotation.serviceNotOperated,
        startTime: annotation.startTime,
        notes: [
            ...(tempNotes ? tempNotes : []).filter((note) => note.annotationId === annotation.id),
            ...annotation.notes.map(noteMapper(annotation.id)),
        ],
    })
